import useGetQuery from '_api/queries/useGetQuery';
import { ConstantsNameDescriptions } from '_api/types';

export const GET_TARGET_SIDE = 'get-target-side';

export const useGetTargetSide = () =>
  useGetQuery<ConstantsNameDescriptions<string>[]>(
    () => `/constant/target-side`,
    {},
    [GET_TARGET_SIDE],
    {
      refetchOnWindowFocus: false,
    },
  );
